/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Delete_Records_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Records" |
*
* @param {Explorer_Display_Delete_Records_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_records_title = /** @type {((inputs?: Explorer_Display_Delete_Records_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Records_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer des enregistrements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensätze löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить записи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar registros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir registros")
	return /** @type {LocalizedString} */ ("Delete Records")
});